import React from 'react';
import { ThemedText } from '../../../components';
import { parseImageList } from '../parsers';

export default function ImageGalleryValue({ value, field, attachments, emptyValue = '—', theme, onImageClick }) {
  const fieldKey = field?.id || field?.key;
  const fieldAttachments = attachments?.filter(
    a => a.fieldName === fieldKey && (a.type === 'Image' || a.type === 'Drawing')
  ) || [];

  const urls = fieldAttachments.length > 0
    ? fieldAttachments.map(a => a.url).filter(Boolean)
    : parseImageList(value);

  if (urls.length === 0) {
    return <ThemedText style={{ color: theme?.colors?.muted }}>{emptyValue}</ThemedText>;
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: theme?.spacing?.sm || 8 }}>
      {urls.map((url, i) => {
        const attachment = fieldAttachments[i];
        const handleClick = onImageClick
          ? (e) => { e.preventDefault(); onImageClick(attachment || { url, fileUrl: url, fileName: `Image ${i + 1}` }); }
          : undefined;

        return (
          <a
            key={i}
            href={url}
            target={onImageClick ? undefined : '_blank'}
            rel={onImageClick ? undefined : 'noopener noreferrer'}
            onClick={handleClick}
            style={{ cursor: 'pointer' }}
          >
            <img
              src={url}
              alt={attachment?.fileName || `${field?.props?.label || 'Image'} ${i + 1}`}
              style={{
                width: 80,
                height: 80,
                objectFit: 'cover',
                borderRadius: theme?.borderRadius?.sm || 4,
                border: `1px solid ${theme?.colors?.border || '#e0e0e0'}`,
              }}
              onError={(e) => {
                e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="150" height="150"%3E%3Crect fill="%23ddd" width="150" height="150"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23999"%3EImage unavailable%3C/text%3E%3C/svg%3E';
              }}
            />
          </a>
        );
      })}
    </div>
  );
}
